module.exports = __webpack_public_path__ + "static/media/card-content-text.6ed017e5.svg";